import { Step, StepType } from '../types/base_step';
import { ProjectType, WindowsNumber } from '../types/windows_answers.types';

export enum WindowsStepName {
  ZipCode = 'zip_code',
  WindowsProject = 'windows_project',
  WindowsNumber = 'windows_number',
  HomeOwner = 'home_owner',
  PersonalInfo = 'personal_info',
  PersonalDetails = 'personal_details',
}

export class ZipCodeStep extends Step {
  constructor() {
    super();
    this.name = WindowsStepName.ZipCode;
    this.type = StepType.ZipCode;
    this.attributes = [
      {
        name: 'zipCode',
        validations: {
          required: true,
        },
        options: [],
      },
    ];
    this.nextStep = WindowsStepName.WindowsProject;
  }
}

export class WindowsProjectStep extends Step {
  constructor() {
    super();
    this.title = 'Which type of window project are you starting?';
    this.name = WindowsStepName.WindowsProject;
    this.type = StepType.Radio;
    this.attributes = [
      {
        name: 'projectType',
        options: [
          { key: 'New', value: ProjectType.New },
          { key: 'Repair', value: ProjectType.Repair },
          { key: 'Replace', value: ProjectType.Replace },
          { key: 'Not sure', value: ProjectType.NotSure },
        ],
      },
    ];

    this.nextStep = WindowsStepName.WindowsNumber;
  }
}

export class WindowsNumberStep extends Step {
  constructor() {
    super();
    this.title = 'How many windows are included?';
    this.name = WindowsStepName.WindowsNumber;
    this.type = StepType.Radio;
    this.attributes = [
      {
        name: 'numberOfWindows',
        options: [
          { key: '1', value: WindowsNumber.One },
          { key: '2', value: WindowsNumber.Two },
          { key: '3-5', value: WindowsNumber.ThreeToFive },
          { key: '6-9', value: WindowsNumber.SixToNine },
          { key: '10+', value: WindowsNumber.TenOrMore },
        ],
      },
    ];
    this.nextStep = WindowsStepName.HomeOwner;
  }
}

export class HomeOwnerStep extends Step {
  constructor() {
    super();
    this.title = 'Are you the homeowner?';
    this.name = WindowsStepName.HomeOwner;
    this.type = StepType.Radio;
    this.attributes = [
      {
        name: 'homeOwner',
        options: [
          { key: 'Yes', value: true },
          { key: 'No', value: false },
        ],
      },
    ];
    this.nextStep = WindowsStepName.PersonalDetails;
  }
}

export class PersonalInfoStep extends Step {
  constructor() {
    super();
    this.title = 'Lock in your best window prices';
    this.name = WindowsStepName.PersonalInfo;
    this.type = StepType.Form;
    this.attributes = [
      {
        name: 'firstName',
        displayName: 'First Name',
        validations: {
          required: true,
          minLength: 2,
        },
      },
      {
        name: 'lastName',
        displayName: 'Last Name',
        validations: {
          required: true,
          minLength: 2,
        },
      },
      {
        name: 'streetAddress',
        displayName: 'Street Address',
        validations: {
          required: true,
          minLength: 5,
        },
      },
    ];
    this.nextStep = WindowsStepName.PersonalDetails;
  }
}

export class PersonalDetailsStep extends Step {
  constructor() {
    super();
    this.title = 'One Last Step to See Your Window Prices!';
    this.name = WindowsStepName.PersonalDetails;
    this.type = StepType.Form;
    this.attributes = [
      {
        name: 'email',
        displayName: 'Email',
        validations: {
          required: true,
          email: true,
        },
      },
      {
        name: 'phoneNumber',
        displayName: 'Phone Number',
        validations: {
          required: true,
          phone: true,
        },
      },
    ];
    this.tcpa = true;
    this.nextStep = undefined; // No next step
  }
}

export const WindowsSteps = [
  new ZipCodeStep(),
  new WindowsProjectStep(),
  new WindowsNumberStep(),
  new HomeOwnerStep(),
  new PersonalInfoStep(),
  new PersonalDetailsStep(),
];
